import React, { memo } from 'react'
import type { SendReminderResponse } from 'src/interfaces/reminder'
import { ResendWithCooldown } from './ResendWithCooldown'

interface Props {
  contractorName: string
  resendAvailableAt: string | null
  onResend(): Promise<SendReminderResponse | null>
}

const ResendInviteComponent = ({ contractorName, resendAvailableAt, onResend }: Props) => {
  return (
    <ResendWithCooldown
      contractorName={contractorName}
      resendAvailableAt={resendAvailableAt}
      onResend={onResend}
      buttonLabel="Resend Invite"
      confirmTitle="Resend onboarding invite?"
      confirmTextPrefix="Resend the onboarding invite to"
      helperLabel="Resend an invite"
      limitReachedText="You can resend the invite once the cooldown period ends."
    />
  )
}

export const ResendInvite = memo(ResendInviteComponent)
